import React, { HTMLProps, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Color, Direction } from '../../../../../utils/constants'
import { twMerge } from 'tailwind-merge'
import ArrowButton from '../../../../../components/Button/variations/ArrowButton'
import { Link } from '../../../../../utils/helpers'
import MovingBackground from '../../../../../partials/MovingBackground/MovingBackground'
import { MovingHeaderSize } from '../../../../../partials/MovingBackground/components/MovingHeader'

interface SolutionCardProps {
  solution: {
    id: string
    link: string
    className: string
    background: {
      component: string
      className?: string
      props?: HTMLProps<HTMLDivElement>
    }
    filter?: string
  }
}

const SolutionCard = ({ solution: { id, link, className, background } }: SolutionCardProps) => {
    const { component, className: bgClassName, props } = background
    const [hovering, setHovering] = useState(false)
    return (
        <Link to={link}>
            <div
                className={twMerge(
                    'aspect-[3/4] md:aspect-auto xl:aspect-[3/4] relative overflow-hidden h-full',
                    'relative overflow-hidden h-full',
                    className,
                )}
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
            >
                <MovingBackground
                    component={component}
                    classes={{
                        wrapper: twMerge('h-full', hovering && 'pointer-events-none'),
                        background: bgClassName,
                    }}
                    size={MovingHeaderSize.SMALL}
                >
                    <div className={twMerge('z-10 p-6 xl:p-8 2xl:p-12 relative flex flex-col h-full')}>
                        <div className={twMerge('flex gap-x-4 mt-auto items-start justify-between')}>
                            <FormattedMessage id={id}>
                                {(value) => (
                                    <span
                                        className={twMerge(
                                            'solution-card--title transition',
                                            hovering ? 'text-white delay-[250ms]' : 'text-black',
                                        )}
                                    >
                                        {value}
                                    </span>
                                )}
                            </FormattedMessage>
                            <ArrowButton
                                buttonColor={hovering ? Color.WHITE : Color.BLACK}
                                direction={Direction.RIGHT}
                                isInverted={hovering}
                            />
                        </div>
                        <div
                            className={twMerge(
                                'z-10 flex items-end h-full pt-32 transition',
                                hovering ? 'text-white' : 'text-black',
                            )}
                        >
                            <FormattedMessage id={`${id}.description`} tagName='p' />
                        </div>
                    </div>
                </MovingBackground>
                <div
                    className='absolute h-full w-full transition-transform duration-500 top-0 ease-in-out'
                    style={{ transform: hovering ? 'translateY(0px)' : 'translateY(100%)' }}
                >
                    <MovingBackground
                        component={component}
                        classes={{ wrapper: 'h-full', background: 'bg-black' }}
                        size={MovingHeaderSize.SMALL}
                        backgroundProps={props}
                    />
                </div>
            </div>
        </Link>
    )
}

export default SolutionCard
